export const MaybeExpandIframe = {
  togglePreviousEmails(iframe, iframeDocument, previousEmails, button) {
    const isHidden = previousEmails.classList.contains("hidden-emails")

    if (isHidden) {
      previousEmails.classList.remove("hidden-emails")
    } else {
      previousEmails.classList.add("hidden-emails")
    }

    iframe.style.height = iframeDocument.body.scrollHeight + "px"
    button.setAttribute("aria-expanded", !isHidden)
  },

  mounted() {
    const expandable = this.el.querySelector(".expand-target")
    const iframe = expandable.querySelector("iframe")
    const expandCollapseToggle = this.el.querySelector(".toggle-target")

    this.handleEvent("refresh_email_body", ({ iframe_id, srcdoc }) => {
      const target = document.getElementById(iframe_id)
      if (target) target.srcdoc = srcdoc
    })

    if (!iframe) {
      console.warn("No iframe found inside the element.")
      return
    }

    const updateToggleVisibility = () => {
      try {
        const iframeDocument = iframe.contentWindow?.document
        if (!iframeDocument) {
          console.warn(
            "Unable to access iframe document. Check cross-origin restrictions.",
          )
          return
        }

        this.setupPreviousEmailsToggle(iframe, iframeDocument)

        const iframeHeight = iframeDocument.body.scrollHeight
        const shouldShow = iframeHeight > 200

        if (shouldShow) {
          expandCollapseToggle.classList.remove("hidden")
        } else {
          expandCollapseToggle.classList.add("hidden")
        }
      } catch (error) {
        console.error("Error accessing iframe content:", error)
      }
    }

    // Observe size changes using ResizeObserver
    const resizeObserver = new ResizeObserver(() => {
      updateToggleVisibility()
    })

    resizeObserver.observe(iframe)

    // Observe when the expandable element comes into view using IntersectionObserver
    const intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Element is back in view, re-evaluate visibility
          updateToggleVisibility()
        }
      })
    })

    intersectionObserver.observe(expandable)

    // Cleanup observers on destroy
    this.destroy = () => {
      resizeObserver.disconnect()
      intersectionObserver.disconnect()
    }
  },

  setupPreviousEmailsToggle(iframe, iframeDocument) {
    const previousEmails = iframeDocument.querySelector(
      "blockquote[type='cite']",
    )

    const existingButton = iframeDocument.querySelector(
      ".previous-emails-button",
    )

    if (previousEmails && !existingButton) {
      const button = iframeDocument.createElement("button")
      button.textContent = "..."
      button.type = "button"
      button.classList.add("previous-emails-button")
      button.onclick = () =>
        this.togglePreviousEmails(
          iframe,
          iframeDocument,
          previousEmails,
          button,
        )

      previousEmails.parentNode.insertBefore(button, previousEmails)
      this.togglePreviousEmails(iframe, iframeDocument, previousEmails, button)
    }
  },

  destroyed() {
    this.destroy && this.destroy()
  },
}
